import {INITIAL_SERVER_DATA, INIT_MEMBER_DETAILS, SET_MEMBER_DATA} from '../../actions/actionTypes';
import LogRocket from 'logrocket';
import {ajax} from "../../common/utils";

export function logRocketReducer(state, action) {
    state = state || {};
    if (!Farmigo.serverData.isProduction || Farmigo.serverData.customerTier !== 'A')
        return state;

    if (action.type === INIT_MEMBER_DETAILS || action.type === SET_MEMBER_DATA) {
        const memberDetails = (action.type === INIT_MEMBER_DETAILS && window.Farmigo) ? window.Farmigo.memberDetails : action.memberDetails;
        if (memberDetails && memberDetails.key) {
            traceLogRocketSession({memberKey: memberDetails.key});
            LogRocket.identify(memberDetails.key, {email:memberDetails.email});
        }
    } else if (action.type === INITIAL_SERVER_DATA) {
        if (window.Farmigo) {
            traceLogRocketSession({farmKey: window.Farmigo.serverData.farmKey});
        }
    }
    return state;
}

function traceLogRocketSession(data){
    LogRocket.getSessionURL((sessionURL) => {
        const fetchUrl = '/dispatcher/WebStoreService.traceLogRocketSession';
        data.recordingURL = sessionURL;
        return ajax(fetchUrl, data)
            .then()
            .catch()
    });
}



// WEBPACK FOOTER //
// ./src/reducers/common/logRocketReducer.js